export const Stocks2 = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M18 16.4805C18.55 16.4805 19 16.9305 19 17.4805V18.4705C19 20.6705 17.5 22.4705 15 22.4705H9C6.5 22.4705 5 20.6705 5 18.4705V17.4805C5 16.9305 5.45 16.4805 6 16.4805H18Z" />
    <path d="M19 6.4707V13.9707C19 14.5207 18.55 14.9707 18 14.9707H6C5.45 14.9707 5 14.5207 5 13.9707V6.4707C5 4.2707 6.5 2.4707 9 2.4707H15C17.5 2.4707 19 4.2707 19 6.4707Z" />
    <path d="M3 21.2207C2.59 21.2207 2.25 20.8807 2.25 20.4707V4.4707C2.25 4.0607 2.59 3.7207 3 3.7207C3.41 3.7207 3.75 4.0607 3.75 4.4707V20.4707C3.75 20.8807 3.41 21.2207 3 21.2207Z" />
    <path d="M21 21.2207C20.59 21.2207 20.25 20.8807 20.25 20.4707V4.4707C20.25 4.0607 20.59 3.7207 21 3.7207C21.41 3.7207 21.75 4.0607 21.75 4.4707V20.4707C21.75 20.8807 21.41 21.2207 21 21.2207Z" />
  </svg>
);
